/** Strings owned by the devices area. */
export const DEVICES_STRINGS = {
    // ── Device card ─────────────────────────────────────────────────────────────
    'devices.commands': { en: 'Commands', ru: 'Команды' },
    'devices.clicker_running': { en: 'Clicker running', ru: 'Кликер запущен' },
    'devices.clicker_flow': { en: 'Flow: {name}', ru: 'Флоу: {name}' },
    'devices.clicker_started_by': { en: 'Clicker started by {login}', ru: 'Кликер запустил {login}' },
    'devices.shift_running': { en: 'Closing shift', ru: 'Закрывается смена' },
    'devices.shift_started_by': { en: 'Shift close started by {login}', ru: 'Закрытие смены запустил {login}' },
    'devices.delete_device': { en: 'Delete device', ru: 'Удалить устройство' },
    'devices.power_off': { en: 'Power off', ru: 'Выключить' },
    'devices.power_on': { en: 'Power on', ru: 'Включить' },
    'devices.last_online': { en: 'Last online: {time}', ru: 'Последний онлайн: {time}' },
    'devices.connect': { en: 'Connect', ru: 'Подключиться' },
    'devices.power_off_confirm': {
        en: 'Power off {name}? The instance stops until it is switched back on.',
        ru: 'Выключить {name}? Инстанс остановится до следующего включения.',
    },
    'devices.power_on_failed': { en: 'Power on failed', ru: 'Не удалось включить' },
    'devices.power_off_failed': { en: 'Power off failed', ru: 'Не удалось выключить' },
    'devices.network_error': { en: 'Network error', ru: 'Ошибка сети' },
    // ── Command popover ─────────────────────────────────────────────────────────
    'devices.device_commands': { en: 'Device commands', ru: 'Команды устройства' },
    'devices.force_refresh_status': { en: 'Force refresh status', ru: 'Принудительно обновить статус' },
    'devices.wake_unlock_screen': { en: 'Wake / unlock screen', ru: 'Разбудить / разблокировать экран' },
    'devices.pin_placeholder': { en: 'PIN (4-16 digits)', ru: 'PIN (4-16 цифр)' },
    'devices.enter_pin': { en: 'Enter PIN', ru: 'Ввести PIN' },
    'devices.installed_apps': { en: 'Installed apps', ru: 'Установленные приложения' },
    'devices.install_apk': { en: 'Install APK', ru: 'Установить APK' },
    'devices.adb_shell': { en: 'ADB shell', ru: 'ADB shell' },
    'devices.screen_off_keep_stream': { en: 'Screen off (keep stream)', ru: 'Выключить экран (стрим не рвать)' },
    'devices.screen_on': { en: 'Screen on', ru: 'Включить экран' },
    'devices.screen_brightness': { en: 'Screen brightness', ru: 'Яркость экрана' },
    'devices.apply_brightness': { en: 'Apply brightness', ru: 'Применить яркость' },
    'devices.reset_session_replug': { en: 'Reset session (re-plug)', ru: 'Сбросить сессию (переподключение)' },
    'devices.restart_phone': { en: 'Restart phone', ru: 'Перезагрузить телефон' },
    'devices.power_off_phone': { en: 'Power off phone', ru: 'Выключить телефон' },
    'devices.command_failed': { en: 'Command failed', ru: 'Команда не выполнена' },
    'devices.installing': { en: 'Installing {file}…', ru: 'Установка {file}…' },
    'devices.install_failed': { en: 'Install failed', ru: 'Не удалось установить' },
    'devices.installed_ok': { en: 'Installed ✓', ru: 'Установлено ✓' },
    'devices.open_stream_first': { en: 'Open the device stream first', ru: 'Сначала откройте стрим устройства' },
    'devices.pin_must_be_digits': { en: 'PIN must contain 4 to 16 digits', ru: 'PIN должен содержать от 4 до 16 цифр' },
    'devices.confirm_session_reset': {
        en: 'Reset the session (re-plug) for {name}? It drops off for a couple of seconds and comes back.',
        ru: 'Сбросить сессию (переподключение) для {name}? Устройство отпадёт на пару секунд и вернётся.',
    },
    'devices.confirm_power_off_phone': { en: 'Really power off {name}?', ru: 'Точно выключить {name}?' },
    'devices.confirm_restart_phone': { en: 'Really restart {name}?', ru: 'Точно перезагрузить {name}?' },
    // ── Grid chrome ─────────────────────────────────────────────────────────────
    'devices.card_size': { en: 'Size', ru: 'Размер' },
    'devices.cards_per_row': { en: 'Per row', ru: 'В ряд' },
    'devices.scroll_left': { en: 'Scroll left', ru: 'Прокрутить влево' },
    'devices.scroll_right': { en: 'Scroll right', ru: 'Прокрутить вправо' },
    // ── Rename / apps / shell / info / comment modals ────────────────────────────
    'devices.rename_device': { en: 'Rename device', ru: 'Переименовать устройство' },
    'devices.device_name': { en: 'Device name', ru: 'Имя устройства' },
    'devices.rename_hint': { en: '(empty = reset to model name)', ru: '(пусто — вернуть имя модели)' },
    'devices.custom_name': { en: 'Custom name', ru: 'Своё имя' },
    'devices.name_too_long': {
        en: 'Device name must be 20 characters or fewer',
        ru: 'Имя устройства — не более 20 символов',
    },
    'devices.failed_to_rename': { en: 'Failed to rename device', ru: 'Не удалось переименовать устройство' },
    'devices.installed_apps_title': { en: 'Installed Apps — {name}', ru: 'Установленные приложения — {name}' },
    'devices.loading_packages': { en: 'Loading packages…', ru: 'Загрузка пакетов…' },
    'devices.failed_to_load_apps': { en: 'Failed to load apps', ru: 'Не удалось загрузить приложения' },
    'devices.no_user_apps': { en: 'No user-installed apps found', ru: 'Пользовательских приложений не найдено' },
    'devices.download_apk': { en: 'Download APK', ru: 'Скачать APK' },
    'devices.adb_shell_title': { en: 'ADB Shell — {name}', ru: 'ADB Shell — {name}' },
    'devices.shell_command_placeholder': { en: 'command…', ru: 'команда…' },
    'devices.send': { en: 'Send', ru: 'Отправить' },
    'devices.shell_disconnected': { en: '[disconnected]', ru: '[соединение закрыто]' },
    'devices.shell_connection_error': { en: '[connection error]', ru: '[ошибка соединения]' },
    'devices.device_id': { en: 'Device ID', ru: 'ID устройства' },
    'devices.manufacturer': { en: 'Manufacturer', ru: 'Производитель' },
    'devices.model': { en: 'Model', ru: 'Модель' },
    'devices.resolution': { en: 'Resolution', ru: 'Разрешение' },
    'devices.video_codec': { en: 'Video codec', ru: 'Видеокодек' },
    'devices.battery': { en: 'Battery', ru: 'Батарея' },
    'devices.wifi_signal': { en: 'Wi-Fi signal', ru: 'Сигнал Wi-Fi' },
    'devices.cellular_signal': { en: 'Cellular signal', ru: 'Сигнал сети' },
    'devices.comment_title': { en: 'Comment · {name}', ru: 'Комментарий · {name}' },
    'devices.comment': { en: 'Comment', ru: 'Комментарий' },
    'devices.comment_hint': {
        en: '(visible to everyone, 500 chars max)',
        ru: '(виден всем, до 500 символов)',
    },
    'devices.comment_placeholder': { en: 'Add a comment…', ru: 'Добавить комментарий…' },
    'devices.comment_too_long': {
        en: 'Comment must be 500 characters or fewer',
        ru: 'Комментарий — не более 500 символов',
    },
    'devices.failed_to_save_comment': { en: 'Failed to save comment', ru: 'Не удалось сохранить комментарий' },
    // ── Share links modal ───────────────────────────────────────────────────────
    'devices.ttl_minutes': { en: 'minutes', ru: 'минут' },
    'devices.ttl_hours': { en: 'hours', ru: 'часов' },
    'devices.ttl_days': { en: 'days', ru: 'дней' },
    'devices.share_expired': { en: 'expired', ru: 'истекла' },
    'devices.share_in_min': { en: 'in {min} min', ru: 'через {min} мин' },
    'devices.share_in_h_min': { en: 'in {h} h {min} min', ru: 'через {h} ч {min} мин' },
    'devices.share_in_h': { en: 'in {h} h', ru: 'через {h} ч' },
    'devices.share_opened_at': { en: 'opened {time}', ru: 'открыта {time}' },
    'devices.share_never_opened': { en: 'never opened', ru: 'не открывалась' },
    'devices.share_by': { en: 'by {login}', ru: 'автор {login}' },
    'devices.share_by_deleted_user': { en: 'by (deleted user)', ru: 'автор (удалённый пользователь)' },
    'devices.share_camera_tag': { en: 'camera', ru: 'камера' },
    'devices.share_revoke': { en: 'Revoke', ru: 'Отозвать' },
    'devices.share_links_title': { en: 'Share links — {name}', ru: 'Ссылки доступа — {name}' },
    'devices.share_intro': {
        en: 'A share link opens this device\'s screen in a browser <strong>without a panel login</strong>. '
            + 'Whoever holds the URL can touch the screen and use the system navigation buttons until '
            + 'the link expires or is revoked.',
        ru: 'Ссылка доступа открывает экран этого устройства в браузере <strong>без входа в панель</strong>. '
            + 'Любой, у кого есть URL, может нажимать на экран и пользоваться системными кнопками навигации, '
            + 'пока ссылка не истечёт или не будет отозвана.',
    },
    'devices.share_valid_for': { en: 'Valid for', ru: 'Срок действия' },
    'devices.share_note': { en: 'Note (optional)', ru: 'Заметка (необязательно)' },
    'devices.share_note_placeholder': { en: 'e.g. verification call', ru: 'например, звонок верификации' },
    'devices.share_allow_camera': { en: 'Allow camera passthrough', ru: 'Разрешить проброс камеры' },
    'devices.share_create': { en: 'Create link', ru: 'Создать ссылку' },
    'devices.share_none': { en: 'No active links.', ru: 'Активных ссылок нет.' },
    'devices.share_failed_load': { en: 'Failed to load links', ru: 'Не удалось загрузить ссылки' },
    'devices.share_ttl_range': {
        en: 'Pick a duration between {min} minutes and 7 days.',
        ru: 'Выберите срок от {min} минут до 7 дней.',
    },
    'devices.share_failed_create': { en: 'Failed to create link', ru: 'Не удалось создать ссылку' },
    'devices.share_failed_revoke': { en: 'Failed to revoke', ru: 'Не удалось отозвать' },
};
